<template>
  <div
    class="is-flex is-align-items-center flex-1 px-5 border-right-2 c-w-sm-100 p-sm-0 border-sm-none"
    :class="[className]"
  >
    <div class="mb-sm-2">
      <p class="averta-bold label-16 mb-4 mb-sm-0 has-text-centered">
        {{ title }}
      </p>
      <div :class="classPhoto">
        <div class="cover-img before p-sm-0 is-flex">
          <div class="wrap-images is-flex is-align-items-center is-justify-content-center">
            <img
              v-if="photo"
              class="images"
              :src="typeof photo === 'object' ? photo.image_url : photo"
              alt=""
            />
            <img v-else :src="require('@/assets/img/empty-before-after.png')" alt="" />
            <img
              v-if="photo"
              class="zoom-preview is-clickable"
              :src="require('@/assets/img/zoom-preview.png')"
              @click="openModalPreviewImage(typeof photo === 'object' ? photo.image_url : photo)"
            />
          </div>
        </div>
        <div
          v-if="footerInformation.length > 0"
          class="border-radius-12 bg-grey-2 flex-center py-1 px-3 mt-4 gap-3"
        >
          <div v-for="(item, index) in footerInformation" :key="index">
            <p class="averta-reguler ">
              <span>{{ item.title }}: </span>
              <span class="averta-bold">{{ item.value || '-' }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateHelper } from '@/helpers'
export default {
  name: 'PhotoPreview',
  props: {
    photo: {
      type: [Object, String],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    className: {
      type: String,
      default: null
    }
  },
  components: {},
  data () {
    return {
      footerInformation: []
    }
  },
  computed: {
    classPhoto () {
      if (this.title === 'Foto Sebelum') {
        return 'is-flex is-flex-direction-column is-align-items-flex-end'
      }
      return ''
    }
  },
  methods: {
    openModalPreviewImage (val) {
      this.$emit('previewImage')
    }
  },
  watch: {},
  mounted () {
    if ('created_by_role' in this.photo) {
      this.footerInformation = [
        {
          title: 'by',
          value: this.photo.created_by_role
        },
        {
          title: 'Via',
          value: this.photo.created_from === 'shell_dashboard' ? 'B2B Shell' : this.photo.created_from
        },
        {
          title: 'Tgl',
          value: formatDateHelper({ date: this.photo.created_at, format: 'DD/MM/YYYY HH:mm' })
        }
      ]
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.cover-img {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 380.31px;
  max-width: 493px;
  position: relative;
  border-radius: 15px;
}

.wrap-images {
  position: relative;
  height: 100%;
  width: auto;
}

.cover-img .wrap-images .images {
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.cover-img.before {
  justify-content: end;
  align-items: center;
}

.cover-img.after {
  justify-content: start;
  align-items: center;
}

.zoom-preview {
  position: absolute;
  bottom: 20px;
  left: 20px;
}
</style>
